export function getProjectsIntro() {
  return (
    <p>
      I like to make elegant but effective products. Here are some of my projects. 
    </p>
  );
}

export function getSkillsIntro() {
  return (
    <p>
      Here is the techology that I already know and also starting to learn.{" "}
    </p>
  );
}

export function getContactIntro() {
  return <p>Say Hi for find me on other platforms: </p>;
}
